// Vista previa (solo lectura) de las tres plantillas del correo de
// confirmación de Resend. No son editables: muestran en texto plano cómo
// llegará el correo al cliente según el método de pago. Los valores entre
// corchetes se rellenan automáticamente con los datos reales del pedido.

const PREFIX = `PCP · Paticas con Propósito
Gracias por comprar con propósito 🐾

Hola [Nombre del cliente],

Tu pedido fue registrado con éxito el [fecha]. Aquí tienes el detalle:

NÚMERO DE PEDIDO
[número de pedido]

(Solo si incluye productos agotados)
Uno de tus productos no está en stock. Lo mandaremos a producción lo antes
posible. Tiempo de entrega estimado en 5-6 días hábiles. Te estaremos avisando
sobre el proceso de compra de tu producto en producción.

PRODUCTOS
[Producto] — Talla [talla] — x[cantidad] — [precio] — [subtotal]

TOTAL
[total]

DATOS DE ENTREGA
Teléfono: [teléfono]
Ciudad: [ciudad]
Dirección: [dirección]
Método de pago: [método de pago]`;

const SUFFIX = `Gracias por apoyar nuestra causa. 🐾`;

const TEMPLATES: Array<{
  id: string;
  title: string;
  icon: string;
  accent: string;
  block: string;
}> = [
  {
    id: 'cod',
    title: 'Pago contra entrega',
    icon: 'ri-cash-line',
    accent: 'text-emerald-700',
    block: `Pago contra entrega
Por favor verifica tus datos de entrega. Si hay algún error, comunícate con
nosotros al [WhatsApp]. Pagarás [total] al recibir tu pedido en la puerta de tu
casa.`,
  },
  {
    id: 'transfer',
    title: 'Nequi / Transferencia',
    icon: 'ri-smartphone-line',
    accent: 'text-amber-700',
    block: `Pago pendiente de confirmación
Tu pago por Nequi / transferencia está pendiente de confirmación. Envía tu
comprobante y comunícate con nosotros al [WhatsApp] para confirmar tu pedido.
Verifica también tus datos de entrega.`,
  },
  {
    id: 'epayco',
    title: 'ePayco (pago en línea)',
    icon: 'ri-bank-card-line',
    accent: 'text-secondary-700',
    block: `Pago en línea confirmado
Tu pago fue realizado en línea. Gracias por tu compra. Por favor verifica tus
datos de entrega; si hay algún error, comunícate con nosotros al [WhatsApp].`,
  },
];

export default function EmailTemplatesPreview() {
  return (
    <div className="space-y-3">
      <div className="p-4 rounded-lg bg-background-50 border border-background-200">
        <p className="text-sm font-medium text-foreground-900 mb-1">
          <i className="ri-eye-line mr-1.5 text-foreground-500"></i>
          Vista previa de las plantillas (no editables)
        </p>
        <p className="text-xs text-foreground-500 leading-relaxed">
          Así llegará el correo al cliente según el método de pago elegido. Los valores entre{' '}
          <code className="text-[11px] bg-background-100 px-1 rounded">[corchetes]</code> se
          rellenan automáticamente con los datos reales del pedido y el WhatsApp configurado.
        </p>
      </div>

      {TEMPLATES.map((t) => (
        <div key={t.id} className="rounded-lg border border-background-200 overflow-hidden">
          <div className="px-4 py-2.5 bg-background-50 border-b border-background-100 flex items-center gap-2">
            <i className={`${t.icon} ${t.accent}`}></i>
            <span className="text-sm font-semibold text-foreground-900">{t.title}</span>
          </div>
          <pre className="m-0 p-4 text-xs text-foreground-700 leading-relaxed whitespace-pre-wrap bg-white font-sans">
            {`${PREFIX}\n\n${t.block}\n\n${SUFFIX}`}
          </pre>
        </div>
      ))}
    </div>
  );
}